const initialState = {open: false}

export default function menu(state = initialState) {
  return state
}
